export default function DataDeletion() {
  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-slate-900">Delete your Chat360 data</h1>
        <p className="text-sm text-slate-500 mt-1">Attendy Technologies · Last updated: 26 October 2026</p>
        <p className="text-slate-600 mt-6 leading-relaxed">You can ask us to delete your Chat360 account and all related data, including WhatsApp account connections, contacts and message history.</p>
        <h2 className="text-lg font-semibold text-slate-900 mt-8">How to request deletion</h2>
        <ol className="list-decimal ml-6 mt-2 text-slate-600 space-y-2">
          <li>Email <a className="text-emerald-700 underline" href="mailto:support@route39.in?subject=Delete%20my%20Chat360%20data">support@route39.in</a> with the subject "Delete my Chat360 data".</li>
          <li>Send it from your registered email, or include your registered mobile number.</li>
          <li>We verify the request and delete your data within 30 days, then confirm by email.</li>
        </ol>
        <p className="text-slate-600 mt-6">If you only messaged a business that uses Chat360, contact that business directly, or email us with your WhatsApp number.</p>
      </div>
    </div>
  );
}
